module.exports = __webpack_public_path__ + "static/bytovka2-3bed55042f7e8b6aa4a88efbb9f4bcdf.jpeg";